import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'expPorcentaje'})

export class ExpedientePorcentajePipe implements PipeTransform {
    transform(arr: any[]): any {
        if (arr ? !arr.length : true) return { valor: 'No disponible',  pendientes: 0};
        //console.log("pipe porcentaje",arr);
        const completos = arr.filter(asd => {
            //console.log("pipe porcentaje",asd.objectId);
           return  asd.objectId !== '' && asd.objectId !== null && asd.objectId !== undefined;
        });
        let porc = {
            valor: `${Math.round(completos.length / arr.length * 100)}%` || 'No disponible',
            pendientes: arr.length - completos.length
        };
        return porc;
    }
}